import {Injectable} from '@angular/core';
import {DatePipe} from "@angular/common";

declare var window: any;

@Injectable()
export class HtmlFormatterService {
    constructor(
        private _datePipe: DatePipe
    ) {}

    public getToolTipHTML(tipId: string, label: string, tipLabel: string, link: string): string {
        return "<span class='a11y-tip a11y-tip--delay'>"
            + "<a href='" + link + "' role='button' class='a11y-tip__trigger' attr.aria-describedby='tt-" + tipId + "'>"
            + label
            + "</a>"
            + "<span attr.id='tt-" + tipId + "' role='tooltip' class='a11y-tip__help a11y-tip__help--top'>" + tipLabel + "</span>"
            + "</span>";
    }

    public formatDate(date, type = 'medium', tzOffset = '') {
        if (date) {
            let dateObj = new Date(date.replace(/([+-])(\d\d)(\d\d)$/, '$1$2:$3'));
            if (!isNaN(dateObj.getTime())) {
                date = this._datePipe.transform(dateObj, type, tzOffset);
            }
            return date;
        }
        return '';
    }

    public formatTzDate(date: string, type = 'medium', tzOffset = '') {
        if (tzOffset === '' && window.USER_TZ_OFFSET) {
            tzOffset = window.USER_TZ_OFFSET;
        }
        return this.formatDate(date, type, tzOffset);
    }
}